<template>
  <div class="emd-select-list" :class="{ '_compact': compact }">
    <ul>
      <li v-for="(item, i) in list" :key="item.id || i" class="emd-select-list__item" :class="{ '_active': item.active, '_disabled': item.disabled }" @click="itemClick(item, $event)">
        <component class="emd-select-list__label" :is="item.to ? 'router-link' : item.href ? 'a' : 'span'"  :href="item.to || item.href || null" >
          <emd-status-tag v-if="item.status" :status="item.status === 'inactive' ? 'danger' : 'success'" />
          {{ item.label }}
        </component>
        <span class="emd-select-list__select-icon" v-if="item.active">
          <i class="uil uil-check-circle" transform="width-16"></i>
        </span>
      </li>
    </ul>
    <div v-if="pagination" class="emd-select-list__pagination">
      <button class="emd-btn _type_text" :class="{ '_disabled': disabled.previous, '_size_small': compact }" :disabled="disabled.previous" @click="goTo('previous')">
        {{ pagination.label.previous }}
      </button>
      <span class="emd-text _size_tiny _align_center">
        {{ pagination.current || '-' }}
        {{ pagination.label.of }}
        {{ pagination.total || '-' }}
      </span>
      <button class="emd-btn _type_text" :class="{ '_disabled': disabled.next, '_size_small': compact }" :disabled="disabled.next" @click="goTo('next')">
        {{ pagination.label.next }}
      </button>
    </div>
  </div>
</template>

<script>
import EmdStatusTag from '../../atoms/emdStatusTag/EmdStatusTag.vue'

export default {
  name: 'EmdSelectList',
  components: {
    EmdStatusTag
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true
    },
    compact: {
      type: Boolean,
      default: false,
      required: false
    },
    pagination: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {
    items: {
      get () {
        return this.list
      },
      set () {}
    },
    disabled () {
      return {
        previous: this.pagination.current === 1,
        next: this.pagination.current === this.pagination.total
      }
    }
  },
  watch: {
    list (value) {
      this.items = [].concat(value)
    }
  },
  methods: {
    goTo (page) {
      if (!this.disabled[page]) {
        this.$emit('goTo', page)
      }
    },
    itemClick (item, event) {
      this.$emit('clickedItem', item, event)
    }
  }
}
</script>
